import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PrincipalConfirmationInput.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { EmploymentPropositionTypes } from "./OE_Types";
import { OMtypes } from "../_loadingHelpers/OM";
import RadioGroup from '../../moreCore/UI/RadioGroup/RadioGroup';
import Edit from '../../moreCore/UI/Edit/Edit';
import lang from 'dojo/_base/lang';

class PrincipalConfirmationInput extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private employmentPropositionID: string;

    private associateHeading: HTMLHeadingElement;
    private inputPropositionDutyType: MdsLax<InstanceType<typeof RadioGroup>>;
    private noteInput: MdsLax<InstanceType<typeof Edit>>;
    private inputConfirmationDutyType: MdsLax<InstanceType<typeof RadioGroup>>;

    private employmentPropositionData: EmploymentPropositionTypes.EmploymentPropositionEntity;

    private _dutyTypeRequest: any = null;
    private loadDutyTypes(): void {

        if (this._dutyTypeRequest != null) return;

        this.StandbyStart();

        // API aufrufen mit Requestmanager...

        this._dutyTypeRequest = this.RequestManager.callfunction(
            "Webtool_API_OrchestraEmploymentProposition__GetDutyTypes",
            {
                jsonData: null
            },
            lang.hitch(this, this._onLoadDutyTypesResponse),
            lang.hitch(this, this._onLoadDutyTypesError),
        );
    }

    private _onLoadDutyTypesResponse(response: Array<OMtypes.dutyType>): void {

        if (this._destroyed) return;

        var dutyTypeProposedID = this.employmentPropositionData.ref_duty_type_proposed ? this.employmentPropositionData.ref_duty_type_proposed.ID : null;
        var dutyTypeConfirmedID = this.employmentPropositionData.ref_duty_type_confirmed ? this.employmentPropositionData.ref_duty_type_confirmed.ID : null;


        this.inputPropositionDutyType.setData(dutyTypeProposedID, response, true, "$Displayname", "ID", "coloration");
        //this.inputPropositionDutyType.setValue(dutyTypeProposedID);
        this.inputConfirmationDutyType.setData(dutyTypeConfirmedID, response, true, "$Displayname", "ID", "coloration");
        this.inputConfirmationDutyType.setValue(dutyTypeConfirmedID);

        this.inputPropositionDutyType.setReadonly(true);
        this.inputConfirmationDutyType.setReadonly(this.inputConfirmationDutyType.getReadonly());

        this.StandbyStop();
    }

    private _onLoadDutyTypesError(error: more.requestErrorMessage): void {
        alert(error.Message);

        this._dutyTypeRequest = null;
    }

    private _onChange_Generic(e: Event): void {
        this.emit("changed");
    }

    public getData(): { employmentPropositionID: string, confirmationDutyTypeID: string }
 {
        var data = {
            employmentPropositionID: this.employmentPropositionID,
            confirmationDutyTypeID: this.inputConfirmationDutyType.getValue("value") as string
        }

        return data;
    }

    setup(data: EmploymentPropositionTypes.EmploymentPropositionEntity) {

        this.employmentPropositionData = data;

        this.employmentPropositionID = data.ID;

        this.associateHeading.innerHTML = data.ref_associate.gDisp_1;
        //this.inputPropositionDutyType.setValue(data.ref_duty_type_proposed ? data.ref_duty_type_proposed.ID : null, true);
        this.noteInput.setValue(data.note, true);
        //this.inputConfirmationDutyType.setValue(data.ref_duty_type_confirmed ? data.ref_duty_type_confirmed.ID : null, true);

        this.loadDutyTypes();

    }

    setReadOnly(bReadOnly): void {
        this.inputConfirmationDutyType.setReadonly(bReadOnly);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any)

        this.noteInput.setReadonly(true);
        

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PrincipalConfirmationInput);
